import React from 'react'

import HeaderTopBar from './components/HeaderTopBar/HeaderTopBar.component'
import HeaderNavBar from './components/HeaderNavBar/HeaderNavBar.component'
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs.components'
import ContactUsHeroSection from './components/ContactUsHeroSection/ContactUsHeroSection.component'
import ContactUsQuoteForm from './components/ContactUsQuoteForm/ContactUsQuoteForm.component'
import FindAnAgent from './components/FindAnAgent/FindAnAgent.component'
import FooterContent from './components/FooterContent/FooterContent.component'
import FooterDisclaimer from './components/FooterDisclaimer/FooterDisclaimer.component'

import './ContactUs.page.scss'

class ContactUsPage extends React.Component {
  componentDidMount() {
    document.title = 'Contact Us | Health Insurance Agency | USA Benefits Group'
  }

  render() {
    return (
      <div id='ContactUsPage'>
        <HeaderTopBar />
        <HeaderNavBar />
        <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Get a Quote' }]} />
        <ContactUsHeroSection />
        <ContactUsQuoteForm />
        <FindAnAgent />
        <FooterContent />
        <FooterDisclaimer />
      </div>
    )
  }
}

export default ContactUsPage
